import TabSelectLabel from '@/Enums/TabSelect/Label.enum';
import CheckListIcon from '@/components/Icons/CheckListIcon';
import MapsLocationIcon from '@/components/Icons/MapsLocationIcon';
import MegaphoneIcon from '@/components/Icons/MegaphoneIcon';
import PacingStatusIcon from '@/components/Icons/PacingStatusIcon';
import ShieldCheckIcon from '@/components/Icons/ShieldCheckIcon';
import SmartTvIcon from '@/components/Icons/SmartTvIcon';
import Tag from '@/components/Icons/Tag';
import TvFilledIcon from '@/components/Icons/TvFilledIcon';
import TabButton from '@/components/TabSelect/TabButton';
import { Person } from '@mui/icons-material';
import { forwardRef } from 'react';

export const CampaignsTabButton = forwardRef((props, ref) => (
  <TabButton {...props} ref={ref} Icon={MegaphoneIcon} label='Campaigns' />
));

export const PacingStatusTabButton = forwardRef((props, ref) => (
  <TabButton {...props} ref={ref} Icon={PacingStatusIcon} label='Pacing Status' />
));

export const ChannelTypesTabButton = forwardRef((props, ref) => (
  <TabButton {...props} ref={ref} Icon={SmartTvIcon} label='Channel Types' />
));

export const WhitelabelsTabButton = forwardRef((props, ref) => (
  <TabButton {...props} ref={ref} Icon={ShieldCheckIcon} label='Whitelabels' />
));

export const ClientsTabButton = forwardRef((props, ref) => (
  <TabButton {...props} ref={ref} Icon={TvFilledIcon} label='Clients' />
));

export const AdvertisersTabButton = forwardRef((props, ref) => (
  <TabButton
    {...props}
    ref={ref}
    Icon={Person}
    iconProps={{ sx: { width: '20px', height: '20px' } }}
    label='Advertisers'
  />
));

export const PlacementsTabButton = forwardRef((props, ref) => (
  <TabButton {...props} ref={ref} Icon={CheckListIcon} label={TabSelectLabel.Placement} />
));

export const LocationsTabButton = forwardRef((props, ref) => (
  <TabButton {...props} ref={ref} Icon={MapsLocationIcon} label={TabSelectLabel.Location} />
));

export const PixelsTabButton = forwardRef((props, ref) => <TabButton {...props} ref={ref} Icon={Tag} label='Pixels' />);
